/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsHeaderViewProps } from '../../../modules/hosports-header/./hosports-header';
import HeaderWrapper from './../../../baseComponents/header/./header-wrapper';

export default (props: IHosportsHeaderViewProps) => {
  let config = props.config;
  let logo = config.icon ? config.icon.src : undefined;
  return (
    <HeaderWrapper
      categories={config.categories}
      lines={config.lines}
      menuItems={config.menuItems}
      site={config.brand}
      logo={logo}
      categoryColumns={config.categoryColumns ? config.categoryColumns : 'four'}
      lineColumns={config.lineColumns}
    />
  );
};
